export enum GoalStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
  Cancelled = 3
}

export enum MilestoneStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
  Cancelled = 3
}

export function getGoalStatusLabel(status: GoalStatus): string {
  switch (status) {
    case GoalStatus.NotStarted:
      return 'circle_details.goal_status_not_started';
    case GoalStatus.InProgress:
      return 'circle_details.goal_status_in_progress';
    case GoalStatus.Completed:
      return 'circle_details.goal_status_completed';
    case GoalStatus.Cancelled:
      return 'circle_details.goal_status_cancelled';
    default:
      return 'circle_details.goal_status_not_started';
  }
}

export function getGoalStatusColor(status: GoalStatus): 'primary' | 'warning' | 'error' {
  switch (status) {
    case GoalStatus.Completed:
      return 'primary';
    case GoalStatus.InProgress:
      return 'primary';
    case GoalStatus.NotStarted:
      return 'warning';
    case GoalStatus.Cancelled:
      return 'error';
    default:
      return 'warning';
  }
}
